import {useTranslation} from "react-i18next";
import {faArrowUp, faAt, faEnvelope, faPhone} from "@fortawesome/pro-solid-svg-icons";

import {Styled} from "./Footer.styles";
import {MAIN_PAGE, RENT_PAGE, STUDIO_PAGE} from "../../../Routes";
import {NAV_ITEMS} from "../navigationItems";
import {Contact__Values} from "../../../PageValues";
import useS115 from "../../../lib/Hooks/useS115";
import {SLUG_BY_CATEGORY} from "../../../lib/products";

const OFFER_LINKS = [
    {labelKey: 'lbl_dj_equipment', path: `${RENT_PAGE}/${SLUG_BY_CATEGORY.DJ}`},
    {labelKey: 'lbl_small_event_equipment', path: `${RENT_PAGE}/${SLUG_BY_CATEGORY.SCENE}`},
    {labelKey: 'lbl_studio', path: STUDIO_PAGE}
]

const Footer = () => {

    const {t} = useTranslation()

    const {navigatePage} = useS115()

    const phone = Contact__Values.phoneNumbers[0]

    return (
        <Styled.Footer>
            <Styled.Inner>
                <Styled.Top>
                    <Styled.Brand>
                        <Styled.Logo onClick={() => navigatePage(MAIN_PAGE)}>
                            S115
                        </Styled.Logo>
                        <Styled.Claim>
                            {t('lbl_footer_claim')}
                        </Styled.Claim>
                    </Styled.Brand>

                    <Styled.Column>
                        <Styled.ColumnTitle>{t('lbl_navigation')}</Styled.ColumnTitle>
                        <Styled.LinkList>
                            {NAV_ITEMS.map((item) => (
                                <Styled.LinkItem key={item.path}>
                                    <Styled.LinkButton onClick={() => navigatePage(item.path)}>
                                        {t(item.labelKey)}
                                    </Styled.LinkButton>
                                </Styled.LinkItem>
                            ))}
                        </Styled.LinkList>
                    </Styled.Column>

                    <Styled.Column>
                        <Styled.ColumnTitle>{t('lbl_offer')}</Styled.ColumnTitle>
                        <Styled.LinkList>
                            {OFFER_LINKS.map((item) => (
                                <Styled.LinkItem key={item.labelKey}>
                                    <Styled.LinkButton onClick={() => navigatePage(item.path)}>
                                        {t(item.labelKey)}
                                    </Styled.LinkButton>
                                </Styled.LinkItem>
                            ))}
                        </Styled.LinkList>
                    </Styled.Column>

                    <Styled.Column>
                        <Styled.ColumnTitle>{t('lbl_contact')}</Styled.ColumnTitle>
                        <Styled.LinkList>
                            <Styled.LinkItem>
                                <Styled.ExternalLink href={`tel:${phone.replace(/\s/g, '')}`}>
                                    <Styled.LinkIcon icon={faPhone}/>
                                    {phone}
                                </Styled.ExternalLink>
                            </Styled.LinkItem>
                            <Styled.LinkItem>
                                <Styled.ExternalLink href={`mailto:${Contact__Values.emailAddress}`}>
                                    <Styled.LinkIcon icon={faEnvelope}/>
                                    {Contact__Values.emailAddress}
                                </Styled.ExternalLink>
                            </Styled.LinkItem>
                            <Styled.LinkItem>
                                <Styled.ExternalLink
                                    href={Contact__Values.instagram}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    <Styled.LinkIcon icon={faAt}/>
                                    {Contact__Values.instagramHandle}
                                </Styled.ExternalLink>
                            </Styled.LinkItem>
                        </Styled.LinkList>
                    </Styled.Column>
                </Styled.Top>

                <Styled.Bottom>
                    <Styled.Copyright>
                        {`© ${new Date().getFullYear()} S115 · ${Contact__Values.city} · ${t('lbl_rights_reserved')}`}
                    </Styled.Copyright>
                    <Styled.BackToTop onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
                        {t('lbl_back_to_top')}
                        <Styled.LinkIcon icon={faArrowUp}/>
                    </Styled.BackToTop>
                </Styled.Bottom>
            </Styled.Inner>
            <Styled.Watermark aria-hidden={true}>S115</Styled.Watermark>
        </Styled.Footer>
    )
}

export default Footer
